import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDashboardSummary } from "../../api/credentialScanning";

export const fetchCredScanSummary = createAsyncThunk(
  "credentialScanning/fetchSummary",
  async () => {
    const { data } = await getDashboardSummary();
    return data;
  }
);

const credentialScanningSlice = createSlice({
  name: "credentialScanning",
  initialState: {
    summary: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSummary(state) {
      state.summary = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCredScanSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCredScanSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.summary = action.payload;
      })
      .addCase(fetchCredScanSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearSummary } = credentialScanningSlice.actions;

// Selector: count for sidebar notification badge (OPEN + CRITICAL findings)
export const selectCredScanBadgeCount = (state) =>
  state.credentialScanning?.summary?.critical || 0;

export default credentialScanningSlice.reducer;
